"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var helpers_1 = require("../helpers");
var useReserveMet = function (lot, topBid, reservePrice) {
    var reserveMet = (0, react_1.useMemo)(function () {
        return (0, helpers_1.isReserveMet)({
            reservePrice: reservePrice !== null && reservePrice !== void 0 ? reservePrice : lot === null || lot === void 0 ? void 0 : lot.reservePrice,
            winningRegisteredProfileAmount: lot === null || lot === void 0 ? void 0 : lot.winningRegisteredProfileAmount,
            overrideWinningBidAmount: lot === null || lot === void 0 ? void 0 : lot.overrideWinningBidAmount,
            topBid: topBid,
        });
    }, [lot === null || lot === void 0 ? void 0 : lot.overrideWinningBidAmount, lot === null || lot === void 0 ? void 0 : lot.reservePrice, lot === null || lot === void 0 ? void 0 : lot.winningRegisteredProfileAmount, topBid, reservePrice]);
    return reserveMet;
};
exports.default = useReserveMet;
